import {
    AlertCircle,
    AlertTriangle,
    ArrowLeft,
    ArrowRight,
    BookOpen,
    Bot,
    Briefcase,
    Check,
    CheckCircle2,
    ChevronDown,
    ChevronRight,
    ChevronUp,
    Code,
    Download,
    Edit,
    Eraser,
    FileText,
    FlaskConical,
    Github,
    HelpCircle,
    History,
    Info,
    Library,
    Lightbulb,
    List,
    Loader2,
    Icon as LucideIcon,
    Menu,
    MessageSquare,
    Moon,
    Paperclip,
    PenLine,
    RefreshCw,
    Search,
    Send,
    Sun,
    Twitter,
    User,
    Wand2,
    X,
} from 'lucide-react';

export type Icon = LucideIcon;

export const Icons = {
    sun: Sun,
    moon: Moon,
    twitter: Twitter,
    github: Github,
    download: Download,
    search: Search,
    history: History,
    info: Info,
    refresh: RefreshCw,
    fileText: FileText,
    paperclip: Paperclip,
    loader: Loader2,
    x: X,
    check: Check,
    chevronDown: ChevronDown,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    bookOpen: BookOpen,
    test: FlaskConical,
    googleDrive: List,
    oneDrive: PenLine,
    send: Send,
    delete: Eraser,
    library: Library,
    message: MessageSquare,
    highlight: Wand2,
    bot: Bot,
    warning: AlertTriangle,
    brief: Briefcase,
    code: Code,
    error: AlertCircle,
    user: User,
    edit: Edit,
    light: Lightbulb,
    help: HelpCircle,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    success: CheckCircle2,
    menu: Menu,
};
